// Cost per Carat Analysis Data
export const costPerCaratData = {
  2024: {
    kpis: {
      costPerCarat: { value: 152, budget: 145, variance: 4.8 },
      materialMoved: { value: 18.5, unit: 'M m³' },
      varianceVsBudget: { value: 4.8, unit: '%' },
      regularCarats: { value: 820, unit: 'k cts' },
      totalOpCost: { value: 125, unit: 'M USD' },
    },
    waterfall: [
      { name: { pt: 'Custo/ct LY', en: 'Cost/ct LY' }, value: 142, type: 'start' },
      { name: { pt: 'Efeito Grade', en: 'Grade Effect' }, value: 5.2, type: 'negative' },
      { name: { pt: 'Efeito Recuperação', en: 'Recovery Effect' }, value: -2.1, type: 'positive' },
      { name: { pt: 'Efeito Minério Tratado', en: 'Ore Processed Effect' }, value: 3.8, type: 'negative' },
      { name: { pt: 'Efeito Strip Ratio', en: 'Strip Ratio Effect' }, value: 2.4, type: 'negative' },
      { name: { pt: 'Custos Mining', en: 'Mining Costs' }, value: 1.8, type: 'negative' },
      { name: { pt: 'Custos Processing', en: 'Processing Costs' }, value: 0.9, type: 'negative' },
      { name: { pt: 'Overhead/Fixos', en: 'Overhead/Fixed' }, value: -1.2, type: 'positive' },
      { name: { pt: 'Diesel/Consumíveis', en: 'Diesel/Consumables' }, value: -0.8, type: 'positive' },
      { name: { pt: 'Custo/ct Actual', en: 'Cost/ct Actual' }, value: 152, type: 'end' },
    ],
    drivers: {
      grade: { value: 0.45, unit: 'ct/m³', vsBudget: -8.2, vsLY: -5.1 },
      recoveryRate: { value: 92.1, unit: '%', vsBudget: 1.1, vsLY: 1.8 },
      oreProcessed: { value: 2.4, unit: 'Mt', vsBudget: -8.0, vsLY: -3.2 },
      wasteMoved: { value: 16.1, unit: 'M m³', vsBudget: 2.5, vsLY: 4.8 },
      stripRatio: { value: 6.7, unit: 'x', vsBudget: 0.8, vsLY: 0.5 },
      plantAvailability: { value: 91.2, unit: '%', vsBudget: -1.8, vsLY: 0.3 },
      plantThroughput: { value: 285, unit: 't/h', vsBudget: -4.2, vsLY: 1.2 },
      dilution: { value: 12.5, unit: '%', vsBudget: 2.1, vsLY: 1.8 },
      oreFeedMix: [
        { source: 'Pit A', percentage: 45, grade: 0.52 },
        { source: 'Pit B', percentage: 35, grade: 0.38 },
        { source: 'Stockpile', percentage: 20, grade: 0.42 },
      ],
    },
  },
  2025: {
    kpis: {
      costPerCarat: { value: 158, budget: 150, variance: 5.3 },
      materialMoved: { value: 21.2, unit: 'M m³' },
      varianceVsBudget: { value: 5.3, unit: '%' },
      regularCarats: { value: 920, unit: 'k cts' },
      totalOpCost: { value: 145, unit: 'M USD' },
    },
    waterfall: [
      { name: { pt: 'Custo/ct LY', en: 'Cost/ct LY' }, value: 152, type: 'start' },
      { name: { pt: 'Efeito Grade', en: 'Grade Effect' }, value: 3.8, type: 'negative' },
      { name: { pt: 'Efeito Recuperação', en: 'Recovery Effect' }, value: -1.5, type: 'positive' },
      { name: { pt: 'Efeito Minério Tratado', en: 'Ore Processed Effect' }, value: -2.2, type: 'positive' },
      { name: { pt: 'Efeito Strip Ratio', en: 'Strip Ratio Effect' }, value: 1.8, type: 'negative' },
      { name: { pt: 'Custos Mining', en: 'Mining Costs' }, value: 2.4, type: 'negative' },
      { name: { pt: 'Custos Processing', en: 'Processing Costs' }, value: 1.2, type: 'negative' },
      { name: { pt: 'Overhead/Fixos', en: 'Overhead/Fixed' }, value: 0.8, type: 'negative' },
      { name: { pt: 'Diesel/Consumíveis', en: 'Diesel/Consumables' }, value: -0.3, type: 'positive' },
      { name: { pt: 'Custo/ct Actual', en: 'Cost/ct Actual' }, value: 158, type: 'end' },
    ],
    drivers: {
      grade: { value: 0.46, unit: 'ct/m³', vsBudget: -5.5, vsLY: 2.2 },
      recoveryRate: { value: 93.4, unit: '%', vsBudget: 2.4, vsLY: 1.3 },
      oreProcessed: { value: 2.7, unit: 'Mt', vsBudget: -3.0, vsLY: 12.5 },
      wasteMoved: { value: 18.5, unit: 'M m³', vsBudget: 4.2, vsLY: 14.9 },
      stripRatio: { value: 6.9, unit: 'x', vsBudget: 0.6, vsLY: 0.2 },
      plantAvailability: { value: 93.5, unit: '%', vsBudget: 0.5, vsLY: 2.3 },
      plantThroughput: { value: 298, unit: 't/h', vsBudget: -1.2, vsLY: 4.6 },
      dilution: { value: 11.8, unit: '%', vsBudget: 1.2, vsLY: -0.7 },
      oreFeedMix: [
        { source: 'Pit A', percentage: 42, grade: 0.54 },
        { source: 'Pit B', percentage: 38, grade: 0.40 },
        { source: 'Stockpile', percentage: 20, grade: 0.41 },
      ],
    },
  },
  2026: {
    kpis: {
      costPerCarat: { value: 153, budget: 148, variance: 3.4 },
      materialMoved: { value: 19.8, unit: 'M m³' },
      varianceVsBudget: { value: 3.4, unit: '%' },
      regularCarats: { value: 950, unit: 'k cts' },
      totalOpCost: { value: 145, unit: 'M USD' },
    },
    waterfall: [
      { name: { pt: 'Custo/ct LY', en: 'Cost/ct LY' }, value: 158, type: 'start' },
      { name: { pt: 'Efeito Grade', en: 'Grade Effect' }, value: -2.5, type: 'positive' },
      { name: { pt: 'Efeito Recuperação', en: 'Recovery Effect' }, value: -1.2, type: 'positive' },
      { name: { pt: 'Efeito Minério Tratado', en: 'Ore Processed Effect' }, value: 1.8, type: 'negative' },
      { name: { pt: 'Efeito Strip Ratio', en: 'Strip Ratio Effect' }, value: -0.8, type: 'positive' },
      { name: { pt: 'Custos Mining', en: 'Mining Costs' }, value: -1.5, type: 'positive' },
      { name: { pt: 'Custos Processing', en: 'Processing Costs' }, value: -0.6, type: 'positive' },
      { name: { pt: 'Overhead/Fixos', en: 'Overhead/Fixed' }, value: 0.5, type: 'negative' },
      { name: { pt: 'Diesel/Consumíveis', en: 'Diesel/Consumables' }, value: -0.7, type: 'positive' },
      { name: { pt: 'Custo/ct Actual', en: 'Cost/ct Actual' }, value: 153, type: 'end' },
    ],
    drivers: {
      grade: { value: 0.48, unit: 'ct/m³', vsBudget: -3.2, vsLY: 4.3 },
      recoveryRate: { value: 94.2, unit: '%', vsBudget: 3.2, vsLY: 0.8 },
      oreProcessed: { value: 2.5, unit: 'Mt', vsBudget: -5.0, vsLY: -7.4 },
      wasteMoved: { value: 17.3, unit: 'M m³', vsBudget: -2.8, vsLY: -6.5 },
      stripRatio: { value: 6.9, unit: 'x', vsBudget: -0.2, vsLY: 0.0 },
      plantAvailability: { value: 94.8, unit: '%', vsBudget: 1.8, vsLY: 1.3 },
      plantThroughput: { value: 305, unit: 't/h', vsBudget: 0.8, vsLY: 2.3 },
      dilution: { value: 10.5, unit: '%', vsBudget: -0.5, vsLY: -1.3 },
      oreFeedMix: [
        { source: 'Pit A', percentage: 48, grade: 0.56 },
        { source: 'Pit B', percentage: 32, grade: 0.42 },
        { source: 'Stockpile', percentage: 20, grade: 0.38 },
      ],
    },
  },
};
